import pathOr from 'ramda/src/pathOr'

export default (routeObj) => {
	const { routeId } = routeObj
	const recordId = pathOr('_', ['routeParams', 'recordId'], routeObj)
	return `${routeId}|${recordId}`
}
